<template>
  <div class="tips-main">
    <div class="tips-box-fa">
      <div class="tips-box">
        <div class="tips-box-top">扫码领取</div>

        <img class="bg-hb" src="@/assets/image/exchangeMethod/bg-hb.png" />

        <div class="hb-box">
          <img
            class="line-left"
            src="@/assets/image/exchangeMethod/line-left.png"
          />
          您有{{ name }}待领取
          <img
            class="line-right"
            src="@/assets/image/exchangeMethod/line-right.png"
          />
        </div>

        <div class="canvas-fa">
          <canvas id="canvas" v-show="!imgshow" class="code"></canvas>
          <img :src="img" alt="" v-show="imgshow" class="code code-img" />
        </div>

        <div class="save">长按保存二维码</div>

        <img
          class="close"
          @click="close"
          src="@/assets/image/exchangeMethod/close.png"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import QRCode from "qrcode";
export default {
  props: ["url", "name"],
  data() {
    return {
      time: null,
      timeNumber: 1,
      agree: false,
      imgshow: false,
      img: null,
      isFlag: false,
      page: 1,
      idCard: "",
      phoneNumber: ""
    };
  },
  methods: {
    ...mapActions(["setAccount"]),
    close() {
      clearInterval(this.time);
      this.time = null;
      this.timeNumber = 1;

      this.idCard = "";
      this.phoneNumber = "";
      this.$emit("close");
    },

    update() {
      this.page = 2;
    },
    copy() {
      this.$copy(this.url);
    }
  },
  mounted() {
    //url为扫描识别后跳转的地方，我这里是动态获取接口的地址
    //width、height分别为生成图片的宽高
    //margin表示图片距离边框的距离

    let canvas = document.getElementById("canvas");
    let url = this.url;
    QRCode.toCanvas(canvas, url, { width: 194, height: 192 }, error => {
      if (error) console.error(error);
    });

    this.img = canvas.toDataURL("image/png");
    this.imgshow = true;
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.tips-main {
  width: 100vw;
  height: 100vh;
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .tips-box-fa {
    background-color: #fff;
    width: 311px;
    height: 419px;
    background: #ffffff;
    border-radius: 12px 12px 12px 12px;
    padding: 4px;
  }
  .tips-box {
    width: 100%;
    height: 100%;
    position: relative;
    background: linear-gradient(
      180deg,
      #fff9e5 0%,
      rgba(255, 255, 255, 0) 100%
    );

    .tips-box-top {
      width: 158px;
      height: 37px;
      background: linear-gradient(270deg, #ffe295 0%, #ffd56a 100%);
      border-radius: 0px 0px 16px 16px;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      line-height: 37px;
      text-align: center;
      color: #691502;
      font-size: 16px;
      font-weight: bolder;
      top: -4px;
    }

    .bg-hb {
      position: absolute;
      right: 0;
      top: 3px;
      width: 62px;
      height: 83px;
    }
    .hb-box {
      position: relative;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-weight: bolder;
      margin-top: 14px;
      color: #701b07;
      .line-left {
        width: 9px;
        margin-right: 14px;
      }
      .line-right {
        width: 9px;
        margin-left: 14px;
      }
    }

    .canvas-fa {
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      justify-content: center;
      align-items: center;
      width: 272px;
      height: 273px;
      background: linear-gradient(89deg, #ff8f3d 0%, #ff4e3e 100%);
      box-shadow: inset 0px 0px 6px 0px #ffffff;
      border-radius: 27px 27px 27px 27px;
      margin-top: 17px;
    }

    .close {
      position: absolute;
      width: 24px;
      height: 24px;
      bottom: -50px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .save {
    color: #701b07;
    font-size: 14px;
    text-align: center;
    margin-top: 15px;
  }
}
</style>
